import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/useAppStore';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useBakerActionsEnabled } from '../../hooks/useBakerActionsEnabled';

function QueueToolbar() {
  const { t } = useTranslation();
  const orders = useAppStore((state) => state.orders);
  const showDoneOrders = useAppStore((state) => state.showDoneOrders);
  const joinSelection = useAppStore((state) => state.joinSelection);
  const loadOrders = useAppStore((state) => state.loadOrders);
  const toggleShowDoneOrders = useAppStore((state) => state.toggleShowDoneOrders);
  const requestStockEdit = useAppStore((state) => state.requestStockEdit);
  const setMode = useSettingsStore((state) => state.setMode);
  const setForm = useSettingsStore((state) => state.setForm);
  const bakerActions = useBakerActionsEnabled();

  const hiddenDoneCount = orders.filter((o) => o.state === 'served').length;

  const openStockEdit = () => {
    // The out-of-stock editor lives inline in the topping picker, so jump
    // there (personalized tab) and let the picker activate it on mount.
    setForm((current) => ({ ...current, menuTab: 'personalized' }));
    requestStockEdit();
    setMode('menu');
  };

  return (
    <div className="px-4 py-4 sm:px-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold">{t('toolbar.title')}</h2>
          {joinSelection.length > 0 && (
            <p className="mt-0.5 text-sm theme-accent">
              {t('toolbar.joinHint', { count: joinSelection.length })}
            </p>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            className="rounded-md border border-[color:var(--app-border)] bg-[color:var(--app-surface)] px-4 py-2 text-sm font-medium transition hover:border-emerald-500/60"
            onClick={loadOrders}
          >
            {t('toolbar.refresh')}
          </button>
          {bakerActions && (
            <button
              className="rounded-md border border-[color:var(--app-border)] bg-[color:var(--app-surface)] px-4 py-2 text-sm font-medium transition hover:border-amber-500/60"
              onClick={openStockEdit}
            >
              {t('toolbar.stockout')}
            </button>
          )}
          <button
            className="rounded-md border border-[color:var(--app-border)] bg-[color:var(--app-surface)] px-4 py-2 text-sm font-medium transition hover:border-emerald-500/60"
            onClick={toggleShowDoneOrders}
          >
            {showDoneOrders ? t('toolbar.hideServed') : t('toolbar.showServed')}
          </button>
        </div>
        {hiddenDoneCount > 0 && !showDoneOrders && (
          <p className="w-full text-sm theme-muted">
            {hiddenDoneCount === 1
              ? t('toolbar.hiddenServedOne', { count: hiddenDoneCount })
              : t('toolbar.hiddenServed', { count: hiddenDoneCount })}
          </p>
        )}
      </div>
    </div>
  );
}

export default QueueToolbar;